<template>
    <div class="columns is-mobile">
        <div class="column">
            <p class="font-weight-600 subtitle has-text-grey-dark is-size-4">{{pageTitle}}</p> 
        </div>
    </div>
</template>

<script>
export default {    
    props: ["pageTitle"]
}
</script>

